<template>
    <div>
        <button @click="handleSaveVideo" class="btn btn-round w-100 cta-hero__cta ml-2 mr-2" :disabled="toggleSaveBtn">
            {{ toggleSaveBtn ? savedButtonText : buttonText }}
        </button>
    </div>
</template>
<script>
import axios from "axios";
export default {
    props: {
        buttonText: {
            type: String,
            default: "Save Video",
        },
        saveEndpoint: {
            type: String,
            required: true,
        },
        videoId: {
            type: String,
            required: true,
        },
        categoryId: {
            type: String,
            required: true,
        },
        savedButtonText: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            toggleSaveBtn: false
        }
    },
    methods: {
        handleSaveVideo() {
            axios
                .post(this.saveEndpoint, {
                    videos: [
                        {
                            videoId: this.videoId,
                            categoryid: this.categoryId,
                        },
                    ],
                    isdelete: false,
                })
                .then(() => {
                    this.toggleSaveBtn = true
                })
                .catch((err) => {
                    console.error("Error:", err);
                });
        },
    },
};
</script>




// WEBPACK FOOTER //
// demo/pages/components/aha-save-teaser-video.vue